
import React from 'react';
import { ResellerPlanDetails } from '@/hooks/license/resellerPlans/types';
import { ActivePlan } from '@/hooks/license/useResellerPlanManagement';
import ResellerPlansHeader from './ResellerPlansHeader';
import EditPlanForm from './EditPlanForm';
import ActivePlansCard from './ActivePlansCard';
import RevenueSettingsCard from './RevenueSettingsCard';

interface ResellerPlansContentProps {
  plans: ResellerPlanDetails[];
  currentPlan: ResellerPlanDetails;
  currentPlanIndex: number;
  activePlans: ActivePlan[];
  currentPlanForCard: ActivePlan | null;
  onSelectPlan: (index: number) => void;
  onAddPlan: () => void;
  onUpdatePlan: (field: keyof ResellerPlanDetails, value: any) => void;
  onAddFeature: () => void;
  onSavePlan: () => Promise<boolean>;
  onTogglePlanEnabled: (planId: string, enabled: boolean) => void;
  isSavingPlan: boolean;
}

const ResellerPlansContent: React.FC<ResellerPlansContentProps> = ({
  plans,
  currentPlan,
  currentPlanIndex,
  activePlans,
  currentPlanForCard,
  onSelectPlan,
  onAddPlan,
  onUpdatePlan,
  onAddFeature,
  onSavePlan,
  onTogglePlanEnabled,
  isSavingPlan
}) => {
  return (
    <div className="p-4">
      <ResellerPlansHeader onAddPlan={onAddPlan} />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <EditPlanForm 
            plan={currentPlan} 
            plans={plans}
            currentPlanIndex={currentPlanIndex}
            onSelectPlan={onSelectPlan}
            onUpdatePlan={onUpdatePlan}
            onAddFeature={onAddFeature}
            onSavePlan={onSavePlan}
            isSaving={isSavingPlan}
          />
        </div>
        
        <div className="space-y-6">
          {currentPlanForCard && (
            <ActivePlansCard 
              plans={[currentPlanForCard]} 
              title="Current Plan"
              description="This is the plan you're currently editing"
              onToggleEnabled={onTogglePlanEnabled}
            />
          )}
          
          <ActivePlansCard 
            plans={activePlans} 
            title="Active Plans"
            description="Plans available to resellers"
            onToggleEnabled={onTogglePlanEnabled}
          />
          
          <RevenueSettingsCard />
        </div>
      </div>
    </div>
  );
};

export default ResellerPlansContent;
